<template>
  <div class="base-list">

    <el-button
      class="add-button"
      v-if="!hideAddNew && hasPermission(createPermission)"
      type="primary"
      icon="el-icon-plus"
      @click="addNew">{{ $t('button.new') }}</el-button>

    <data-table
      :model="model"
      :columns="columns"
      :size="10"
      :operations="operations"
      v-loading.body="loading"
    />

    <el-dialog
      :title="$t('title.remove')"
      :visible="!!modelToDelete"
      width="30%"
      :before-close="() => { modelToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="deleteModel">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: 'base-list',
  data () {
    return {
      modelToDelete: null
    }
  },
  props: {
    model: {
      type: String,
      required: true
    },
    sModel: {
      type: String,
      required: true
    },
    serverId: {
      type: String,
      default: 'server_id'
    },
    columns: {
      type: Array,
      required: true
    },
    hideEditOperation: {
      type: Boolean,
      default: false
    },
    hideDeleteOperation: {
      type: Boolean,
      default: false
    },
    hideAddNew: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    detailsRouteName () {
      return `${this.sModel}-edit`
    },
    operations () {
      return [
        {
          label: 'edit',
          icon: 'edit',
          permission: [this.editPermission, this.model[this.serverId]],
          precondition: () => !this.hideEditOperation,
          method: (model) => this.$router.push({ name: `${this.sModel}-edit`, params: { 'id': model.id } })
        },
        {
          label: 'delete',
          type: 'danger',
          icon: 'delete',
          permission: [this.deletePermission, this.model[this.serverId]],
          precondition: () => !this.hideDeleteOperation,
          method: (model) => (this.modelToDelete = model)
        }
      ]
    },
    createPermission () {
      return `CREATE_${this.sModel.toUpperCase().replace('-', '_')}`
    },
    editPermission () {
      return `EDIT_${this.sModel.toUpperCase().replace('-', '_')}`
    },
    deletePermission () {
      return `DELETE_${this.sModel.toUpperCase().replace('-', '_')}`
    },
    loading () {
      return this.$store.getters[`${this.model}/loading`]
    }
  },
  methods: {
    addNew () {
      this.$router.push({ name: this.detailsRouteName, params: { 'id': 'new' } })
    },
    deleteModel () {
      this.$store.dispatch(`${this.model}/delete`, this.modelToDelete)
      this.modelToDelete = null
    }
  }
}
</script>

<style lang="scss">
.base-list {

  .add-button {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// BaseList.vue?92554878